import { FormattedMessage } from "react-intl";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang.js";
import HtmlView from "component/htmlView/html-view.js";
import { API_BASE_URL } from "configs/AppConfig.js";

function PublicationIntro({ publication, currentLocale }) {
  const hasName =
    publication?.name !== null && publication?.name !== undefined;
  const hasDescription =
    publication?.description !== null &&
    publication?.description !== undefined;

  return (
    <div className="row mb-4">
      <div className="col-12 col-lg-8">
        <div className="item-news-s">
          <h2>
            {hasName ? (
              <LabelLang
                id="name"
                defaultValue={publication.name}
                translations={publication.publicationTranslations}
              />
            ) : (
              <FormattedMessage id="data-not-found" />
            )}
          </h2>
          <p>
            {hasDescription ? (
              <HtmlView
                html={LabelLangString({
                  id: "description",
                  currentLocale,
                  defaultValue: publication.description,
                  translations: publication.publicationTranslations,
                })}
              />
            ) : (
              <FormattedMessage id="data-not-found" />
            )}
          </p>
        </div>
      </div>
      <div className="col-12 col-lg-4 mt-5">
        <div className="item-book">
          <img
            loading="lazy"
            className="w-100"
            src={
              publication?.cover !== null && publication?.cover !== undefined
                ? `${API_BASE_URL}/${publication.cover}`
                : process.env.PUBLIC_URL + "/image/book.png"
            }
            alt="book"
          />
        </div>
      </div>
    </div>
  );
}

export default PublicationIntro;
